import type { GraphDocument } from '@/domain/funnel/graph-document';
import { EXPORT_FORMAT, EXPORT_FORMAT_VERSION, type DarkFunnelsExportPackage } from './contracts';
import { sanitizeGraphForExport } from './sanitize-export';

export function buildExportPackage(input: {
  name: string;
  description?: string | null;
  graph: GraphDocument;
  exportedAt?: Date;
}): DarkFunnelsExportPackage {
  const graph = sanitizeGraphForExport(input.graph);
  return {
    format: EXPORT_FORMAT,
    formatVersion: EXPORT_FORMAT_VERSION,
    schemaVersion: graph.schemaVersion,
    exportedAt: (input.exportedAt ?? new Date()).toISOString(),
    metadata: {
      name: input.name.trim() || 'Imported funnel',
      ...(input.description !== undefined ? { description: input.description } : {}),
    },
    graph,
  };
}

export function serializeExportPackage(value: DarkFunnelsExportPackage): string {
  return JSON.stringify(value, null, 2);
}
